import { ClusterLayer, type ClusterProps } from './cluster-layer'

export function ClustersLargest(props: ClusterProps) {
	return <ClusterLayer {...props} size="largest" />
}
